import React from 'react';
import {
  MDBBreadcrumb,
  MDBBreadcrumbItem,
  MDBContainer,
  MDBNavbar,
} from 'mdb-react-ui-kit';
import { Link } from 'react-router-dom';

export default function Breadcrumb({ paths }) {
  return (
    <MDBNavbar expand='lg'>
      <MDBContainer>
        <MDBBreadcrumb>
          {paths.map((item, index) => (
            <MDBBreadcrumbItem
              key={index}
              active={index === paths.length - 1}
            >
              {index === paths.length - 1 ? (
                <span className='display-10 AcerhealthTextPurple'>
                  {item.name}
                </span>
              ) : (
                <Link to={item.link} className='display-10 AcerhealthTextPurple'>
                  {item.name}
                </Link>
              )}
            </MDBBreadcrumbItem>
          ))}
        </MDBBreadcrumb>
      </MDBContainer>
    </MDBNavbar>
  );
}